import {Item} from '../../generated/types';
import {ItemRarityNames} from './item-rarity-names';
import {ItemTypeNames} from './item-type-names';

export function getItemRarity(item: Item) {
	const type = item.type && ItemTypeNames[item.type];
	const typeGenus: 'male' | 'female' | 'other' | 'multiple' | null = type ? type.genus : 'male';
	return item.rarity && typeGenus && ItemRarityNames[item.rarity] && ItemRarityNames[item.rarity][typeGenus];
}
